import React from 'react';
import { product } from '../../data/product';
export function SiteHeader() {
  return <header className="w-full bg-ivory" data-id="element-172" data-mp="29prh44kudz48">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5 lg:px-10" data-id="element-173" data-mp="29rm03dcjzh5o">
        <span className="font-serif text-xl tracking-tight text-carbon" data-id="element-174" data-mp="1v2g6q60ecl5p">
          Buena Vibra<span className="text-gold-ink" data-id="element-175" data-mp="2019h3pkdzw1n">X</span>
        </span>
        <a href="#comprar" className="text-sm font-medium text-carbon underline decoration-gold decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-ink" data-id="element-176" data-mp="2npso81rpa2s5">
          Quiero mi Ebook
        </a>
      </div>
      <span className="sr-only" data-id="element-177" data-mp="2eouhhbpvnh5v">{product.brand}</span>
    </header>;
}